import Footer from '@/components/elements/navigation/footer';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

export default function Login() {
  return (
    <div className='flex h-screen flex-col'>
      <header className='flex items-center justify-between px-4 py-3'>
        <div className='flex items-center gap-4'>
          <div className='md:hidden'>
            <div className='flex items-center gap-4'>
              <Sheet>
                <SheetContent side={'left'} className='w-full bg-slate-600'>
                  <SheetHeader>
                    <SheetTitle>Air Reserve Menu</SheetTitle>
                  </SheetHeader>
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      </header>
      <div className='flex grow content-center items-center p-5'>
        <div className='hidden flex-col p-5 sm:block'>
          <Image
            className='mx-auto dark:hidden'
            src={'/light-LargeLogo.png'}
            width={350}
            height={300}
            style={{ height: 'auto' }}
            alt='Logo'
            priority={true}
          />
          <Image
            className='mx-auto hidden dark:block'
            src={'/dark-LargeLogo.png'}
            width={350}
            height={300}
            style={{ height: 'auto' }}
            alt='Logo'
            priority={true}
          />
        </div>
        <div className='mx-auto flex-col p-5'>
          <Button
            onClick={() => {
              window.location.assign(
                `${window.location.protocol}//${window.location.host}/api/logto/sign-in`
              );
            }}
          >
            Click Here to Sign-In
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
